<nav class="toolbar navbar navbar-light toolbar-no-button"></nav> <!--emarti69: nav vacío debido a que el scroll está hecho en base a la altura del container y del footer. La existencia del nav influye en la altura del scroll, por tanto se necesita que haya uno, aunque no tenga botón, del tamaño de los que tienen botón.-->
<div id="homebox" class="container-fluid container-list">
    <div class="home-margin-box">
        <div>
            <span>
                <img src="assets/images/Titulo_Pol_Protección_Datos.png" />
            </span>
        </div>
        <br />
        <br />
        <b><u><span>{{title}}</span></u></b>
        <br />
        <br />
        <div>
            {{p1}}<b>{{p1Negrita}}</b>{{p1Continuacion}}
            <br />
            <br />
            <ul>
                <li>{{p1l1}}</li>
                <li>{{p1l2}}</li>
                <li>{{p1l3}}</li>
            </ul>
        </div>
        <br />
        <div>
            <b>{{p2title}}</b>
            <ol>
                <li>
                    <b>{{p2Tl1}}</b>{{p2l1}}
                    <br />
                    {{p2l1Direccion}}
                    <br />
                    {{p2l1Telefono}}
                    <br />
                    {{p2l1Email}} <a href="inspfito@mapama.es">inspfito&#64;mapa.es</a>
                    <br />
                    {{p2l1Delegado}} <a href="bzn-delegadosPD@mapama.es">bzn-delegadosPD&#64;mapa.es</a>
                    <br />
                    <br />
                </li>

                <li>
                    <b>{{p2Tl2}}</b>{{p2l2}}
                    <br />
                    <br />
                    <table id="tableProteccionDatos" style="border:1px solid black;">
                        <tr>
                            <th>
                                {{p2th1}}
                            </th>
                            <th>
                                {{p2th2}}
                            </th>
                        </tr>
                        <tr>
                            <td>
                                {{p2td11}}
                            </td>
                            <td>
                                {{p2td12}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {{p2td21}}
                            </td>
                            <td>
                                {{p2td22}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {{p2td31}}
                            </td>
                            <td>
                                {{p2td32}}
                            </td>
                        </tr>
                    </table>
                    <br />
                </li>

                <li>
                    <b>{{p2Tl3}}</b>{{p2l3}}
                    <br />
                    <br />
                </li>

                <li>
                    <b>{{p2Tl4}}</b>{{p2l4}}
                    <br />
                    <br />
                </li>

                <li>
                    <b>{{p2Tl5}}</b>{{p2l51}}
                    <br />
                    {{p2l52}}
                    <br />
                    <a href="https://sede.mapa.gob.es/portal/site/seMAPA/navProteccionDatos">https://sede.mapa.gob.es/portal/site/seMAPA/navProteccionDatos</a>
                </li>
            </ol>
        </div>
    </div>
</div>

